<template>
  <div class="qikan-item-container">
    <custom-router-link :item="info" class="qikan-item-link" :to="{name: 'QikanDetails', params: {id: info.id}}" target="_blank">
      <div class="qikan-item-image">
        <el-image :src="projectFileUrl + info.image" fit="cover" v-if="info.image"></el-image>
        <el-image :src="require('@/assets/images/img3.png')" fit="cover" v-else></el-image>
      </div>
      <div class="qikan-item-details">
        <div class="qikan-item-title">{{info.name}}</div>
        <!-- <div class="qikan-item-summary">{{info.summary}}</div>
        <div class="qikan-item-more">
          <div class="publish-time">{{info.publishTime && info.publishTime.split(" ")[0]}}</div>
          <div class="more-info">
            <span>了解更多&nbsp;<i class="el-icon-right"></i></span>
          </div>
        </div> -->
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.qikan-item-container {
  width: 100%;
  .qikan-item-link {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.02);
    .qikan-item-image {
      width: 100%;
      height: 400px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .qikan-item-details {
      width: 100%;
      padding: 14px;
      .qikan-item-title {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 10px;
        color: #212529;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .qikan-item-summary {
        width: 100%;
        font-size: 15px;
        color: #6c757d;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
    .publish-time {
      font-size: 14px;
      line-height: 22px;
      color: #6c757d;
      margin-top: 10px;
    }
    .qikan-item-more {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #6c757d;
    }
    .more-info {
      display: flex;
      font-size: 16px;
      color: #212529;
      line-height: 32px;
      span {
        border-bottom: 2px solid #2960a7;
        font-weight: 600;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .qikan-item-container {
    .qikan-item-link {
      box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.04);
      .qikan-item-image {
        width: 100%;
        height: auto;
        aspect-ratio: 5/8;
        overflow: hidden;
      }
      .qikan-item-details {
        .qikan-item-title {
          font-size: 18px;
          line-height: 24px;
          margin-bottom: 6px;
        }
      }
      .publish-time {
        font-size: 12px;
        line-height: 22px;
        color: #6c757d;
        margin-top: 0;
      }
      .qikan-item-more {
        padding: 0;
      }
      .more-info {
        display: flex;
        font-size: 12px;
        color: #212529;
        line-height: 24px;
        span {
          border-bottom: 1px solid #2960a7;
          font-weight: 600;
        }
      }
    }
  }
}
</style>